/* global axios */
import ApiClient from '../ApiClient';

// R6.4: sandbox de calibração do Bira (recurso singular por conta).
// Abrir rascunho, editar, testar contra conversa real, publicar e reverter.
class SandboxAPI extends ApiClient {
  constructor() {
    super('fandata/sandbox', { accountScoped: true });
  }

  // T-186: a base de conhecimento e o jeito de falar do Bira publicam em separado, cada um com
  // o seu rascunho. `escopo` diz de qual dos dois se está falando; sem ele, é a base.
  show(escopo) {
    return axios.get(this.url, { params: escopo ? { escopo } : {} });
  }

  abrir(escopo) {
    return axios.post(this.url, escopo ? { escopo } : {});
  }

  salvar(payload) {
    return axios.patch(this.url, payload);
  }

  descartar(escopo) {
    return axios.delete(this.url, { params: escopo ? { escopo } : {} });
  }

  // T-186: o índice da base, com o estado de cada card e o resumo do rascunho.
  indice(params = {}) {
    return axios.get(`${this.url}/indice`, { params });
  }

  // T-186: a tela inicial da Base de conhecimento (no ar, rascunho e versões).
  linhaDoTempo({ busca, tipo } = {}) {
    return axios.get(`${this.url}/linha_do_tempo`, { params: { busca, tipo } });
  }

  // T-186: uma versão antiga, em só leitura.
  versao(id) {
    return axios.get(`${this.url}/versao`, { params: { id } });
  }

  // T-186: traz a base daquele dia para o rascunho. Nunca vai direto ao ar.
  // escopo: 'tudo' (padrão), 'respostas' ou 'comportamento'.
  restaurar(id, escopo = 'tudo') {
    return axios.post(`${this.url}/restaurar`, { id, escopo });
  }

  // T-186: a história do jeito de falar, só as versões em que a voz mudou.
  // Sem id, a lista e o que está no ar. Com id (ou 'atual'), uma voz só, com a anterior ao lado.
  comportamento(id) {
    return axios.get(`${this.url}/comportamento`, { params: id ? { id } : {} });
  }

  // T-186: um card e o histórico dele, na mesma chamada.
  card(numero, tipo = 'faq') {
    return axios.get(`${this.url}/card`, { params: { numero, tipo } });
  }

  // T-186: traz uma revisão antiga de UM card para o rascunho.
  reverterCard(revisaoId) {
    return axios.post(`${this.url}/reverter_card`, { revisao_id: revisaoId });
  }

  // Conversas encerradas para escolher no teste.
  conversas() {
    return axios.get(`${this.url}/conversas`);
  }

  // { conversa_id } ou { texto }. Não envia nada ao torcedor.
  testar(payload) {
    return axios.post(`${this.url}/testar`, payload);
  }

  // escopo: 'novas' (padrão, preserva quem já está falando com o Bira) ou 'todas'.
  // `escopo` é O QUE sobe (base ou comportamento); `alcance` é PARA QUEM (T-120).
  publicar(escopo, alcance = 'novas') {
    return axios.post(`${this.url}/publicar`, { escopo, alcance });
  }

  // Horário combinado para publicar. Só alimenta o aviso, não bloqueia.
  janela(inicio, fim) {
    return axios.post(`${this.url}/janela`, { inicio, fim });
  }

  // T-156: o detalhe de uma publicação, item a item.
  mudancas(versaoId) {
    return axios.get(`${this.url}/mudancas`, {
      params: { versao_id: versaoId },
    });
  }

  // T-186 tela 5a: o que vai ao ar se publicar agora, com o texto de hoje ao lado do novo, mais
  // o estado da publicação (janela, teste, conversas em andamento) na mesma resposta.
  diff(tipo = 'faq', escopo) {
    return axios.get(`${this.url}/diff`, { params: { tipo, escopo } });
  }

  // T-186 Fase 4. `aplicar` falso é PRÉVIA: o servidor roda a importação de verdade e desfaz,
  // e responde na hora. Com `aplicar`, a importação vai para a fila e a resposta é só o
  // "aceitei"; o andamento vem de `importacao()`.
  importar(conteudo, aplicar = false) {
    return axios.post(`${this.url}/importar`, { conteudo, aplicar });
  }

  // Onde a importação em curso está. `estado` nulo = não há nada rodando.
  importacao() {
    return axios.get(`${this.url}/importacao`);
  }

  exportar(versao) {
    return axios.get(`${this.url}/exportar`, {
      params: { versao },
      responseType: 'blob',
    });
  }

  reverter(versaoId) {
    return axios.post(`${this.url}/reverter`, { versao_id: versaoId });
  }
}

export default new SandboxAPI();
